import { TypeSettingsWithoutUnresolvableLinksResponse } from '@shared/features/contentful/_generated';
import { Document as RTDocument } from '@contentful/rich-text-types';

type TSettings = {
    [key: string]: string | boolean | TSettings | RTDocument;
};

enum SETTINGS_TYPES {
    BOOLEAN = 'Boolean',
    LONG_TEXT = 'Long text',
    SHORT_TEXT = 'Short text',
    RICH_TEXT = 'Rich text',
    PLACEHOLDER = 'Placeholder',
}

enum SETTINGS_FIELDS {
    BOOLEAN = 'valueBoolean',
    LONG_TEXT = 'valueLong',
    SHORT_TEXT = 'value',
    RICH_TEXT = 'valueRich',
}

type SettingsTypes = `${SETTINGS_TYPES}`;

const getValueFiledNameByContentType = (type?: SettingsTypes): SETTINGS_FIELDS => {
    switch (type) {
        case SETTINGS_TYPES.BOOLEAN:
            return SETTINGS_FIELDS.BOOLEAN;
        case SETTINGS_TYPES.LONG_TEXT:
            return SETTINGS_FIELDS.LONG_TEXT;
        case SETTINGS_TYPES.SHORT_TEXT:
        case SETTINGS_TYPES.PLACEHOLDER:
            return SETTINGS_FIELDS.SHORT_TEXT;
        case SETTINGS_TYPES.RICH_TEXT:
            return SETTINGS_FIELDS.RICH_TEXT;
        default:
    }
    return SETTINGS_FIELDS.SHORT_TEXT;
};

/**
 * Creates a settings object from an array of settings entries.
 * @param settings - An optional array of settings entries.
 * @returns The settings object.
 */
const createSettingsObject = (settings?: TypeSettingsWithoutUnresolvableLinksResponse[]) => {
    // Add Array.isArray() check for safety
    if (!settings || !Array.isArray(settings) || settings.length === 0) {
        return {};
    }

    return settings.reduce((result: TSettings, setting) => {
        if (!setting?.fields?.name) return result;

        const { name, type } = setting.fields;
        const settingValue = setting.fields[getValueFiledNameByContentType(type)];

        if (settingValue === undefined) return result;

        const keyParts = name.split('.');
        name.split('.').reduce((current, key, index) => {
            if (
                index === keyParts.length - 1 &&
                setting.fields[getValueFiledNameByContentType(type)]
            ) {
                current[key] = settingValue;
            } else {
                if (!current[key]) {
                    current[key] = {};
                }
                return current[key] as TSettings;
            }
            return current;
        }, result);

        return result;
    }, {} as TSettings);
};

export default createSettingsObject;
